<template>
    <div>
        <b-card class="m-3" id="processo-mesa-trabalho-header-Card" no-body header-tag="header">
            <template #header>
                <h6 class="mb-0 text-center titulo-sagres font-weight-bold" v-b-toggle.accordion-1>
                    <font-awesome-icon icon="chevron-down"
                        :class="['float-left', filtrosVisiveis ? 'rotating-up' : 'rotating-down']"
                        style="margin-top: 0.75rem" />
                    Pesquisar Processos
                    <btn-limpar :clearMethod="limparFormulario" />
                    <b-button size="sm" class="float-right m-1" @click.stop="abrirCriacaoProtocolo">
                        <font-awesome-icon icon="plus" class="mr-3" />
                        Criar Protocolo
                    </b-button>
                </h6>
            </template>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel" v-model="filtrosVisiveis">
                <b-card-body>
                    <b-container>
                        <b-row>
                            <b-col cols="12" lg="3">
                                <b-form-group id="input-group-type" label-size="md" label="Nº Processo">
                                    <b-form-input v-model="filtros.numero" placeholder="TC/123456/2022"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="5">
                                <b-form-group id="input-group-type" label-size="md" label="CPF ou Nome de Interessado">
                                    <b-form-input v-model="filtros.interessado"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="2">
                                <b-form-group id="input-group-type" label-size="md" style="white-space: nowrap"
                                    label="Situação">
                                    <b-form-select v-model="filtros.situacao" @input="clearMultiselect()">
                                        <b-form-select-option value="0">Ativos</b-form-select-option>
                                        <b-form-select-option value="1">Cancelados</b-form-select-option>
                                        <b-form-select-option value="2" selected>Todos</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="2">
                                <b-form-group id="input-group-type" label-size="md" style="white-space: nowrap"
                                    label="Julgamento">
                                    <b-form-select v-model="filtros.julgado">
                                        <b-form-select-option value="0" selected>Todos</b-form-select-option>
                                        <b-form-select-option value="1">Julgados</b-form-select-option>
                                        <b-form-select-option value="2">Não Julgados</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" v-if="filtros.julgado === '1'">
                                <DateRangePickerBase v-model="filtros.dataJulgamento"
                                    title="Filtre pela data de julgamento (opcional)" />
                            </b-col>
                            <b-col cols="12" id="mesa-trabalho" lg="6">
                                <b-form-group id="input-group-type" label-size="md" label="Unidade Gestora">
                                    <multiselect v-model="filtros.ug" open-direction="bottom" :close-on-select="true"
                                        :searchable="true" label="Nome" :show-labels="false" deselect-label=""
                                        :allow-empty="true" placeholder="Todos" track-by="Codigo" :options="optionsUG">
                                        <template slot="noOptions">
                                            <small><i>Erro ao obter dados.</i></small>
                                        </template>
                                        <template slot="noResult">
                                            <i>Sem resultados.</i>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                            <b-col id="mesa-trabalho" cols="12" lg="6">
                                <b-input-group>
                                    <b-form-group id="input-group-type" label-size="md" style="width: 86%" label="Tipo">
                                        <multiselect v-model="filtros.tipo" open-direction="bottom"
                                            :close-on-select="true" :searchable="true" label="Descricao"
                                            :show-labels="false" deselect-label="" :allow-empty="true"
                                            placeholder="Todos" track-by="Cod" :options="optionsTipo">
                                            <template slot="noOptions">
                                                <small><i>Erro ao obter dados.</i></small>
                                            </template>
                                            <template slot="noResult">
                                                <i>Sem resultados.</i>
                                            </template>
                                        </multiselect>
                                    </b-form-group>
                                    <template #append>
                                        <b-button @click="clearMultiselect">Limpar</b-button>
                                    </template>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" lg="5">
                                <b-form-group id="input-group-type" label-size="md" label="Assunto">
                                    <b-form-input v-model="filtros.assunto"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" lg="5">
                                <DateRangePickerBase v-model="filtros.dataEntrada" title="Data de Entrada" />
                            </b-col>
                            <b-col cols="12" lg="2" style="margin-top:1.7rem!important">
                                <b-button @click="filtrarProcessos">
                                    <font-awesome-icon icon="search" class="mr-2" />Pesquisar
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-card class="m-3" id="processo-mesa-trabalho-table-Card" no-body header-tag="header">
            <template #header>
                <h6 class="mb-0 text-center">Resultados</h6>
            </template>
            <b-card-text>
                <b-table :busy="isBusy" :fields="fields" hover no-border-collapse :items="items" sort-by=""
                    :sort-desc="true" striped stacked="sm" per-page="0" :current-page="currentPage" show-empty>
                    <template #empty>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #emptyfiltered>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-dark">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong class="loading-text">Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(Numero)="row">
                        <b-link @click="openDetalheProtocoloProcesso(row.item)">{{ row.item.Numero }}</b-link>
                        <BadgeCancelamento :motivo="row.item.MotivoCancelamento" />
                    </template>
                    <template v-slot:cell(DataEntrada)="row">
                        <span>{{ formatData(row.item.DataEntrada) }}</span>
                    </template>
                </b-table>
                <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="perPage" @pageChange="pageChange"
                    :firstCurrentPg="currentPage">
                </table-pagination>
            </b-card-text>
        </b-card>
    </div>
</template>
<script>
import DateRangePickerBase from '@/components/shared/DateRangePickerBase.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Multiselect from "vue-multiselect";
import TablePagination from '@/components/atos-pessoal/TablePagination.vue'
import BtnLimpar from '@/components/shared/BtnLimpar.vue'
import { storeProtocolosProcessosAdm } from '@/stores/StoreProtocolosProcessos'
import { UtilsTS } from '@/utilsts';
import protocoloService from '@/services/processos-eletronicos/protocoloService'
import ugService from "@/services/administracao/ugService"
import { fieldsConsultasEtce } from '@/types/processo-eletronico/table-fields-consultas-etce';
import { filtrosVazios } from '@/types/processo-eletronico/filtro-processo-eletronico';
import BadgeCancelamento from '@/components/processo-eletronico/BadgeCancelamento.vue';
import { trackProtocoloMatomoEvent } from '@/utils/matomo';

export default {
    name: 'MesaTrabalhoAdmin',
    components: {
        BadgeCancelamento,
        BtnLimpar,
        DateRangePickerBase,
        Multiselect,
        TablePagination
    },
    mixins: [UtilsTS],
    data() {
        return {
            filtrosVisiveis: true,
            filtros: {
                dataEntrada: { startDate: null, endDate: null },
                dataJulgamento: { startDate: null, endDate: null }
            },
            errorMessage: "",
            perPage: 10,
            currentPage: 1,
            totalRows: 0,
            optionsTipo: [],
            optionsUG: [],
            isBusy: false,
            fields: [...fieldsConsultasEtce],
            items: [],
        };
    },
    computed: {
        dataEntradaInicio() {
            return this.formatDataDB(this.filtros.dataEntrada.startDate)
        },
        dataEntradaFim() {
            return this.formatDataDB(this.filtros.dataEntrada.endDate)
        },
        dataJulgamentoInicio() {
            return this.formatDataDB(this.filtros.dataJulgamento.startDate)
        },
        dataJulgamentoFim() {
            return this.formatDataDB(this.filtros.dataJulgamento.endDate)
        },
    },
    async mounted() {
        this.obterDadosDaStore()
        let response = await protocoloService.listarTiposProcessos()
        let tipoProcesso = response.data
        tipoProcesso = this.sortArrayObjectByKey(tipoProcesso, 'Descricao').map(t => {
            let n = Object.assign(t)
            n.Descricao = 'Processo - ' + this.capitalize(n.Descricao)
            return n
        })
        response = await protocoloService.listarTiposProtocolos()
        let tipoDocumento = response.data
        this.sortArrayObjectByKey(tipoDocumento, 'Descricao').map(t => {
            let n = Object.assign(t)
            n.Descricao = 'Protocolo - ' + this.capitalize(n.Descricao)
            return n
        })
        this.optionsTipo = tipoProcesso.concat(tipoDocumento)
        await this.obterUgsAtivas()
    },
    methods: {
        abrirCriacaoProtocolo() {
            trackProtocoloMatomoEvent('criacao_clicada', 'consulta_admin');
            this.$router.push('/criarProtocolo');
        },
        openDetalheProtocoloProcesso(item) {
            this.$router.push({ name: "detalhe-protocolo-processo", "params": { item: item, cancelado: this.situacao } })
        },
        obterDadosDaStore() {
            this.filtros = {
                ...storeProtocolosProcessosAdm.filtros,
            }
            this.totalRows = storeProtocolosProcessosAdm.totalRows
            this.items = storeProtocolosProcessosAdm.items
            this.currentPage = storeProtocolosProcessosAdm.currentPage
        },
        sincronizarStore() {
            storeProtocolosProcessosAdm.filtros = { ... this.filtros }
            storeProtocolosProcessosAdm.totalRows = this.totalRows
            storeProtocolosProcessosAdm.items = this.items
            storeProtocolosProcessosAdm.currentPage = this.currentPage
        },
        limparFormulario() {
            this.filtros = {
                ...filtrosVazios,
                dataEntrada: { startDate: null, endDate: null }
            }
            this.totalRows = 0
            this.items = []
            this.currentPage = 1
            this.sincronizarStore()
        },
        pageChange(value) {
            this.currentPage = value;
            this.filtrarProcessos()
        },
        clearMultiselect() {
            this.filtros.tipo = null
        },
        formatarInteressados(interessados) {
            return interessados && interessados.length > 0 ? interessados.map((i) => { return i.Nome }).join(', ') : '-'
        },
        getInteressado() {
            let isCPF = this.validarCPF(this.filtros.interessado)
            return { 'isCPF': isCPF, 'value': this.filtros.interessado.trim().length > 0 ? this.filtros.interessado.trim() : '' }
        },
        async obterUgsAtivas() {
            try {
                const response = await ugService.obterUgsAtivas()
                if (response && response.status === 200) {
                    this.optionsUG = this.formatedUGLabels(response.data)
                } else {
                    throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao buscar UGs ativas!')
                }
            } catch (e) {
                console.error(e)
                this.$toast.error(e.message ? e.message : e);
            } finally {
                this.isBusy = false
            }
        },
        async filtrarProcessos() {
            try {
                this.isBusy = true
                const data = new FormData()
                data.append("numero", this.filtros.numero)
                data.append("assunto", this.filtros.assunto)
                if (this.getInteressado().isCPF)
                    data.append("cpfInteressado", this.getInteressado().value)
                else
                    data.append("nomeInteressado", this.getInteressado().value)
                data.append("tipo", this.filtros.tipo && this.filtros.tipo.Cod ? this.filtros.tipo.Cod : '')
                if (this.filtros.situacao !== '2')
                    data.append("cancelados", this.filtros.situacao === '1')
                data.append("codUG", this.filtros.ug ? this.filtros.ug.Codigo : '')
                data.append("dataEntradaInicio", this.dataEntradaInicio)
                data.append("dataEntradaFim", this.dataEntradaFim)
                data.append("pagina", this.currentPage)
                data.append("regPorPagina", 10)
                if (this.filtros.julgado != 0)
                    data.append("julgados", this.filtros.julgado == '1')
                if (this.filtros.julgado === '1' && this.filtros.dataJulgamento && this.filtros.dataJulgamento.startDate && this.filtros.dataJulgamento.endDate) {
                    data.append("dataJulgamentoInicio", this.dataJulgamentoInicio)
                    data.append("dataJulgamentoFim", this.dataJulgamentoFim)
                }

                const response = await protocoloService.carregarProcessosProtocoloAdmin(data)
                if (response && response.status === 200) {
                    this.totalRows = response.data.Total
                    this.items = response.data.Protocolos
                } else {
                    if (response.data && response.data.msg) {
                        this.$toast.error(response.data.msg);
                    } else {
                        this.$toast.error('Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!');
                    }
                }
            } catch (e) {
                console.error(e)
                this.totalRows = 0
                this.items = []
                this.$toast.error('Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!');
            } finally {
                this.isBusy = false
                this.sincronizarStore()
            }
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style></style>
